<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-body">
		<!-- 				 -->
		<!-- School Selector -->
		<!-- 				 -->
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
				</caass-schoolselector>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleActive()">Toggle Active</button>
		<button class="btn btn-success" style="margin-left: 5px" (click)="onEdit()">Edit Alert</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddIncident()">Add Incident Alert</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddEvent()">Add Event Alert</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddBroadcast()">Add Broadcast Alert</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total Alerts: {{ lstAlert.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 				  	    -->
<!-- Display Location Items -->
<!-- 					    -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstAlert"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedAlert"
		dataKey="AlertID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-06">
					<div class="table-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActive
								[ngModel]="value"
								[options]="lstActives"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="AlertDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th class="fixwidth-12">
					<p-columnFilter field="AlertTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAlertTypeDesc
								[ngModel]="value"
								[options]="lstAlertTypeDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-12">
					<p-columnFilter field="Applied" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterApplied
								[ngModel]="value"
								[options]="lstApplieds"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-12">
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstrDefinedByDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th class="fixwidth-06"></th>
				<th pSortableColumn="Active" class="fixwidth-09">Active<p-sortIcon field="Active"></p-sortIcon></th>
				<th pSortableColumn="AlertDesc">Description<p-sortIcon field="AlertDesc"></p-sortIcon></th>
				<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
				<th class="fixwidth-12" pSortableColumn="AlertTypeDesc">Type<p-sortIcon field="AlertTypeDesc"></p-sortIcon></th>
				<th class="fixwidth-12" pSortableColumn="Applied">Schools<p-sortIcon field="Applied"></p-sortIcon></th>
				<th class="fixwidth-12" pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rAlertItem>
			<tr [pSelectableRow]="rAlertItem" (dblclick)="onRowDblClick(rAlertItem)">
				<td class="fixwidth-06">
					<!-- Fee space filler -->
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rAlertItem.Active,
								'pi-ban table-inactive': !rAlertItem.Active
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="table-data-location">
						{{ rAlertItem.AlertDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-location" style="font-weight: bold" [ngStyle]="{ color: rAlertItem.FontColor }">
						{{ rAlertItem.Message }}
					</div>
				</td>

				<td>
					<div
						class="table-data-location fixwidth-12"
						[ngClass]="{
							'table-color-type-1': rAlertItem.AlertTypeID == 1,
							'table-color-type-2': rAlertItem.AlertTypeID == 2,
							'table-color-type-3': rAlertItem.AlertTypeID == 3,
							'table-color-type-4': rAlertItem.AlertTypeID == 4
						}"
					>
						{{ rAlertItem.AlertTypeDesc }}
					</div>
				</td>

				<td>
					<div
						class="table-data-location fixwidth-12"
						[ngClass]="{
							'table-color-aply-1': rAlertItem.SchoolID <= 0 && rAlertItem.AlertTypeID != 4,
							'table-color-aply-2': rAlertItem.SchoolID <= 0 && rAlertItem.AlertTypeID == 4,
							'table-color-aply-2': rAlertItem.SchoolID > 0
						}"
					>
						{{ rAlertItem.SchoolList }}
					</div>
				</td>

				<td>
					<div
						class="table-data-location fixwidth-12"
						[ngClass]="{
							'table-color-def-1': rAlertItem.DefinedByID == 1,
							'table-color-def-2': rAlertItem.DefinedByID == 2,
							'table-color-def-3': rAlertItem.DefinedByID == 3,
							'table-color-def-4': rAlertItem.DefinedByID == 4
						}"
					>
						{{ rAlertItem.DefinedByDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Location -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstAlert.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Alerts configured...</label>
</div>
